import { namespace } from 'vuex-class';
import { IUpdateGoogleDocsState } from '@/dealroom/google-docs/store/update-google-docs.types';

export const UpdateGoogleDocs = namespace('dealroom/updateGoogleDocs');

export const state: IUpdateGoogleDocsState = {
  pageCount: 0,
  importedPages: [],
  error: null,
};

export enum EUpdateGoogleDocsAction {
  SetPageCount = 'setPageCount',
  LoadPage = 'loadPage',
  LoadPageSuccess = 'loadPageSuccess',
  LoadPageFailed = 'loadPageFailed',
  Reset = 'reset',
}

export enum EUpdateGoogleDocsMutation {
  SetPageCount = 'setPageCount',
  SetPages = 'setPages',
  SetState = 'setState',
  SetError = 'setError',
}

export enum EUpdateGoogleDocsGetter {
  Progress = 'progress',
}
